import Form from "@/app/components/UI/Form";
import Head from "next/head";

export default function ContactAboutPage() {
	return (
		<>
			<Head>
				<title>Sobre Azul Agro - Atendimento</title>
				<meta
					name="description"
					content="Entre em contato com a Azul Agro para saber mais sobre nossa empresa, história, missão e valores. Estamos prontos para responder suas dúvidas e fornecer mais informações sobre nossas soluções agrícolas de alta performance."
				/>
			</Head>
			<main>
				<Form about />
			</main>
		</>
	);
}
